import { useCallback, useEffect, useRef, useState } from 'react';
import { isAndroid, isIos, isStandaloneApp } from '../lib/pwa.js';

export function usePwaInstall() {
  const deferredRef = useRef(null);
  const [canPrompt, setCanPrompt] = useState(false);
  const [installed, setInstalled] = useState(isStandaloneApp);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setInstalled(isStandaloneApp());

    const onInstallable = (event) => {
      event.preventDefault();
      deferredRef.current = event;
      setCanPrompt(true);
    };

    const onInstalled = () => {
      deferredRef.current = null;
      setCanPrompt(false);
      setInstalled(true);
    };

    window.addEventListener('beforeinstallprompt', onInstallable);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onInstallable);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const install = useCallback(async () => {
    const prompt = deferredRef.current;
    if (!prompt) return { ok: false, reason: 'unavailable' };

    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    deferredRef.current = null;
    setCanPrompt(false);

    if (outcome === 'accepted') {
      setInstalled(true);
      return { ok: true };
    }
    return { ok: false, reason: 'dismissed' };
  }, []);

  const dismiss = useCallback(() => {
    setDismissed(true);
  }, []);

  const showInstall =
    !installed &&
    !dismissed &&
    (canPrompt || isAndroid() || isIos());

  const hint = isIos()
    ? 'Safari → Partilhar → Adicionar ao ecrã inicial'
    : isAndroid()
      ? canPrompt
        ? 'Instala como app na home screen'
        : 'Menu ⋮ → Instalar app ou Adicionar ao ecrã inicial'
      : 'Usa o menu do browser para instalar';

  return {
    showInstall,
    canPrompt,
    installed,
    install,
    dismiss,
    hint,
    isMobile: isAndroid() || isIos(),
  };
}
